import { TiendaPerfectaVisitHistoryStop } from 'models/TiendaPerfecta';

import { VisitSelection, stopMatchesSelection } from './selection';

export interface SelectionScope {
  active: boolean;
  dates: Set<string>;
  vanIds: Set<string>;
  zoneIds: Set<string>;
}

/**
 * What the current selection touches: the dates, vans and zones of the stops
 * that match it. The charts keep every element and dim those outside.
 */
export const selectionScope = (
  stops: TiendaPerfectaVisitHistoryStop[],
  selection: VisitSelection
): SelectionScope => {
  const scope: SelectionScope = {
    active: selection !== null,
    dates: new Set(),
    vanIds: new Set(),
    zoneIds: new Set(),
  };
  if (!selection) return scope;

  stops
    .filter((stop) => stopMatchesSelection(stop, selection))
    .forEach((stop) => {
      scope.dates.add(stop.plannedDate);
      scope.vanIds.add(stop.van.id);
      scope.zoneIds.add(stop.zone.id);
    });

  return scope;
};

export const isDimmed = (
  scope: SelectionScope,
  kind: 'date' | 'van' | 'zone',
  id: string
): boolean => {
  if (!scope.active) return false;
  const set =
    kind === 'date'
      ? scope.dates
      : kind === 'van'
      ? scope.vanIds
      : scope.zoneIds;

  return !set.has(id);
};

/** Clicking what is already selected clears the selection. */
export const toggleSelection = (
  current: VisitSelection,
  next: NonNullable<VisitSelection>
): VisitSelection =>
  current && JSON.stringify(current) === JSON.stringify(next) ? null : next;
